var render = function render(_c,_vm){return _c('div',_vm._g({key:"placeholder",class:{
        [_vm.$style.root]: true,
        'cursor-pointer': _vm.listeners.click != null
    },attrs:{"title":`${_vm.parent.type} placeholder`}},{
        ..._vm.listeners.click && {
            click: () => _vm.listeners.click(_vm.$event)
        }
    }),[_c('mark',{class:_vm.$style.mark},[_vm._v(_vm._s((_vm.data.attrs && _vm.data.attrs.title) || _vm.parent.$t(_vm.parent.$attrs['data-name'] || _vm.parent.type)))]),_c('code',{class:_vm.$style.code},[(_vm.scopedSlots.default != null)?_c('div',[_vm._t("default")],2):_vm._e(),(_vm.scopedSlots.slot != null)?_c('div',{class:{
                [_vm.$style.slot]: true,
                [_vm.$style['slot--active']]: _vm.injections.hasSlotContent({ parent: _vm.parent })
            },attrs:{"title":"slot area"}},[_vm._t("slot",function(){return [_vm._v("Slot content")]})],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }